import { DELETE } from '../../dataFetchActions';
import { CRUD_DELETE } from './crudconstants';

/** @deprecated We are phasing out legacy redux, use immi query instead */
export const crudDelete = (
  resource,
  resourceId,
  params = {}
) => {
  const { subResource, customAction, context, redirectTo, refresh = true, data, previousData, id } = params;
  return {
    type: CRUD_DELETE,
    payload: { id: resourceId, previousData, data },
    meta: {
      resource,
      context,
      id,
      customAction,
      subResource,
      fetch: DELETE,
      onSuccess: {
        notification: {
          body: 'notification.deleted',
          level: 'info',
          messageArgs: {
            smart_count: 1,
          },
        },
        refresh,
        redirectTo,
      },
      onFailure: {
        notification: {
          body: 'notification.http_error',
          level: 'warning',
        },
      },
    }
  }
};
